if ($("html").length && $("body").length) {
  const $html = $("html");
  const $body = $("body");
  let wasMenuOpen = false;
  let keepScrolledUp = false;
  const sync = function () {
    const isMenuOpen = $body.hasClass("navigation-window-visible");
    if (isMenuOpen && !wasMenuOpen) {
      keepScrolledUp = $html.hasClass("scrolled-up");
    }
    if (!isMenuOpen) {
      keepScrolledUp = false;
    } else if (keepScrolledUp && !$html.hasClass("scrolled-up")) {
      $html.addClass("scrolled-up");
    }

    wasMenuOpen = isMenuOpen;
  };
  sync();
  if (typeof MutationObserver !== "undefined") {
    new MutationObserver(sync).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }
  $(window).on("scroll.customScroll resize.customScroll", sync);
}
